/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */


import { doc, getDoc, setDoc, getFirestore, collection, addDoc, onSnapshot } from "firebase/firestore"
import { auth, db, welcomeFunction } from './firebase.js';
import { createUserWithEmailAndPassword, onAuthStateChanged, signInWithEmailAndPassword, sendPasswordResetEmail, getAuth, signOut } from 'firebase/auth';




export const initializeSession = async (user) => {
    const session = { user };
    const data = await fetchUserData(user);
    if (data) {
        session.user.data = data;
    }
    return session;
}





export const fetchUserData = async (user) => {
    if (user) {
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            if (data) user.displayName = data.displayName;
            return data;
        } else {
            // Document doesn't exist, so create a new entry
            const defaultData = {
                userId: user.uid,
                displayName: user.displayName || "Anonymous",
                email: user.email,
                createdAt: new Date().toISOString(),
                subscription: {
                    status: '',
                    plan: 'free',
                    lastPaymentDate: null
                }
            };
            
            await setDoc(docRef, defaultData);
            console.log("New user document created.");
            return defaultData;
        }
    }

    return null;
};










export const stripeCheckout = async ({
    session, priceId, successUrl, cancelUrl
}) => {
    try {
        // Reference the checkout_sessions sub-collection
        const checkoutSessionsRef = collection(db, `users/${session?.user?.uid}/checkout_sessions`);
        console.log(checkoutSessionsRef);

        // Add checkout session document
        const docRef = await addDoc(checkoutSessionsRef, {
            price: priceId, // Replace with your Stripe price ID
            success_url: successUrl || window.location.origin,
            cancel_url: cancelUrl || window.location.origin,
        });

        // Listen for changes in the document
        onSnapshot(docRef, (snap) => {
            const data = snap.data();

            if (data?.error) {
                alert(`An error occurred: ${data.error.message}`);
            }

            if (data?.url) {
                // Redirect to Stripe Checkout URL
                window.location.assign(data.url);
            }
        });

    } catch (error) {
        console.error('Checkout Error:', error);
        alert('Something went wrong. Please try again.');
    }
};